import { contacts, copyRight } from '../constants/Contact';
import styles from './styles/Contact.module.css';

const Contact = () =>
{
    return (
        <div className={styles.container}>
            <div className={styles.background}> </div>

            <div className={styles.emailBtnContainer}>
                {contacts.map(( contact, index) =>
                    <div key={index} className={styles.emailBtn}>
                        <a href={`mailto:${contact}`} className={styles.email}>{contact}</a>
                    </div>
                )}
            </div>

            <div className={styles.copyright}>{copyRight}</div>
        </div>
    )
}

export default Contact;